import { useEffect, useState } from 'react';

const CHECK_INTERVAL_MS = 2 * 60 * 1000;

// El build de CRA referencia el bundle como /static/js/main.<hash>.js; el hash
// cambia en cada deploy, así que basta comparar el del index.html publicado con
// el que está corriendo en el navegador.
const MAIN_BUNDLE_REGEX = /\/static\/js\/main\.[\w]+\.js/;

const getRunningBundle = (): string | null => {
  const script = Array.from(document.scripts).find((s) => MAIN_BUNDLE_REGEX.test(s.src));
  return script?.src.match(MAIN_BUNDLE_REGEX)?.[0] ?? null;
};

const getPublishedBundle = async (): Promise<string | null> => {
  const response = await fetch(`/index.html?v=${Date.now()}`, { cache: 'no-store' });
  if (!response.ok) return null;
  const html = await response.text();
  return html.match(MAIN_BUNDLE_REGEX)?.[0] ?? null;
};

const NewVersionBanner: React.FC = () => {
  const [hasNewVersion, setHasNewVersion] = useState(false);

  useEffect(() => {
    const runningBundle = getRunningBundle();
    // En desarrollo (npm start) no hay bundle con hash: no hay nada que comparar.
    if (!runningBundle) return;

    const checkForNewVersion = async () => {
      try {
        const publishedBundle = await getPublishedBundle();
        if (publishedBundle && publishedBundle !== runningBundle) setHasNewVersion(true);
      } catch {
        // Sin conexión o error de red: se reintenta en el siguiente ciclo.
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') checkForNewVersion();
    };

    const interval = window.setInterval(checkForNewVersion, CHECK_INTERVAL_MS);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  if (!hasNewVersion) return null;

  return (
    <div className="gm-new-version-banner" role="status">
      <span>
        Hay una nueva versión de GrowMe disponible. Guarda lo que estés haciendo y recarga la página para ver los últimos cambios.
      </span>
      <button type="button" onClick={() => window.location.reload()}>
        Recargar
      </button>
    </div>
  );
};

export default NewVersionBanner;
